import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'blog',
  setup(__props) {

// Blog layout with sticky TOC
useMarketingScripts();

return (_ctx: any,_cache: any) => {
  const _component_TopHeader = _resolveComponent("TopHeader")!
  const _component_UPage = _resolveComponent("UPage")!
  const _component_UContainer = _resolveComponent("UContainer")!
  const _component_UMain = _resolveComponent("UMain")!

  return (_openBlock(), _createBlock(_component_UMain, null, {
    default: _withCtx(() => [
      _createVNode(_component_UContainer, null, {
        default: _withCtx(() => [
          _createVNode(_component_UPage, { class: "pt-30 max-w-6xl mx-auto" }, {
            default: _withCtx(() => [
              _createVNode(_component_TopHeader),
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})